import { inject, Injectable } from '@angular/core';
import { CONFIG } from '@nano/core/config';
import {
  PaymentCompletedStatuses,
  PaymentDeclinedStatuses,
  PaymentInitiatedStatuses,
  PaymentPendingStatuses,
  PaymentReservedStatuses,
  PaymentReversedStatuses,
  PaymentStatus
} from '../payment-entry';
import { PaymentStatusUI } from './payment-entry-status';

@Injectable({
  providedIn: 'root'
})
export class PaymentEntryStatusService {
  private config = inject(CONFIG);

  getPaymentStatusUI(paymentStatus: PaymentStatus, waitForFunds?: boolean): PaymentStatusUI {
    if (this.config.amlStatusUnderReviewEnabled && (paymentStatus === PaymentStatus.SUSPENDED || paymentStatus === PaymentStatus.VERIFICATION)) {
      return PaymentStatusUI.UNDER_REVIEW;
    }

    if (PaymentReservedStatuses.includes(paymentStatus)) {
      return PaymentStatusUI.RESERVED;
    } else if (PaymentCompletedStatuses.includes(paymentStatus)) {
      return PaymentStatusUI.COMPLETED;
    } else if (PaymentInitiatedStatuses.includes(paymentStatus)) {
      return PaymentStatusUI.INITIATED;
    } else if (PaymentPendingStatuses.includes(paymentStatus)) {
      return paymentStatus === PaymentStatus.CONFIRMED && waitForFunds ? PaymentStatusUI.WAIT_FOR_FUNDS : PaymentStatusUI.PENDING;
    } else if (PaymentDeclinedStatuses.includes(paymentStatus)) {
      return PaymentStatusUI.DECLINED;
    } else if (PaymentReversedStatuses.includes(paymentStatus)) {
      return PaymentStatusUI.REVERSED;
    }
  }
}
